import { h } from 'preact';
import { useState } from 'preact/hooks';
import { t } from '../i18n.js';
import { route } from 'preact-router';
import LanguageSwitcher from '../components/shared/LanguageSwitcher.jsx';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ForgotPasswordView() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !EMAIL_REGEX.test(email.trim())) {
      setError(t('auth.errors.invalid_email_format'));
      return;
    }
    setError('');
    setLoading(true);
    try {
      await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() })
      });
    } catch (_) {
      // Intentionally ignored — always show generic success
    }
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <div class="login-page">
      <div style="position:absolute;top:20px;right:20px">
        <LanguageSwitcher />
      </div>

      <div class="login-card">
        <div class="login-logo">S</div>
        <h1 class="login-title">{t('auth.forgotPasswordTitle')}</h1>

        {submitted ? (
          <>
            <p style="color:var(--color-text-muted);font-size:14px;line-height:1.6;margin-bottom:24px">
              {t('auth.forgotPasswordSuccess')}
            </p>
            <button
              class="btn btn-primary btn-lg"
              style="width:100%"
              onClick={() => route('/login')}
            >
              {t('auth.backToLogin')}
            </button>
          </>
        ) : (
          <>
            <p class="login-subtitle">{t('auth.forgotPasswordSubtitle')}</p>
            {error && <div class="alert alert-error">{error}</div>}
            <form onSubmit={handleSubmit} noValidate>
              <div class="form-group">
                <label class="form-label">{t('auth.email')}</label>
                <input
                  class="form-input"
                  type="email"
                  value={email}
                  onInput={(e) => setEmail(e.target.value)}
                  autocomplete="email"
                  autoFocus
                />
              </div>
              <button
                class="btn btn-primary btn-lg"
                style="width:100%;display:flex;align-items:center;justify-content:center;gap:8px"
                type="submit"
                disabled={loading}
              >
                {loading && <span class="btn-spinner" />}
                {loading ? t('common.loading') : t('auth.forgotPassword')}
              </button>
            </form>
            <p style="text-align:center;margin-top:16px">
              <a
                href="/login"
                style="font-size:14px;color:var(--color-primary);text-decoration:none"
                onClick={(e) => { e.preventDefault(); route('/login'); }}
              >
                {t('auth.backToLogin')}
              </a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
